import { Translations } from '../types';

export const vi: Translations = {
  common: {
    loading: 'Đang tải...',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Sửa',
    back: 'Quay lại',
    next: 'Tiếp theo',
    submit: 'Gửi',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    all: 'Tất cả',
    viewAll: 'Xem tất cả',
    copy: 'Sao chép',
    copied: 'Đã sao chép!',
    success: 'Thành công',
    error: 'Lỗi',
    close: 'Đóng',
  },
  nav: {
    home: 'Trang chủ',
    linkExchange: 'Liên kết sàn',
    rebate: 'Hoàn phí',
    exchanges: 'Sàn Giao Dịch',
    withdraw: 'Rút tiền',
    history: 'Lịch sử',
    checkIn: 'Điểm danh',
    profile: 'Cá nhân',
    overview: 'Tổng quan',
    rewardHub: 'Phần thưởng',
    settings: 'Cài đặt',
  },
  dashboard: {
    title: 'Xin chào, {name}!',
    subtitle: 'Tổng quan tài khoản của bạn',
    balance: 'Số dư',
    totalEarned: 'Tổng thu nhập',
    pendingRebate: 'Hoàn phí chờ xử lý',
    availablePoints: 'XP khả dụng',
    recentRebates: 'Hoàn phí gần đây',
    recentWithdrawals: 'Rút tiền gần đây',
  },
  linkExchange: {
    title: 'Liên kết tài khoản sàn',
    subtitle: 'Kết nối UID sàn của bạn để kích hoạt theo dõi phí giao dịch tự động',
    exchange: 'Sàn giao dịch',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: 'Liên kết tài khoản',
    linkedAccounts: 'Tài khoản đã liên kết',
    status: 'Trạng thái',
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    delete: 'Xóa tài khoản',
    selectExchange: 'Chọn sàn giao dịch',
    enterUID: 'Nhập UID',
    enterApiKey: 'Nhập API Key',
    enterApiSecret: 'Nhập API Secret',
    accountLinked: 'Liên kết tài khoản thành công',
    accountDeleted: 'Xóa tài khoản thành công',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: 'Hoàn phí giao dịch',
    subtitle: 'Lịch sử thanh toán hoàn phí tự động',
    totalRebate: 'Tổng hoàn phí',
    pendingRebate: 'Hoàn phí chờ xử lý',
    balance: 'Số dư',
    withdraw: 'Rút tiền',
    rebateHistory: 'Lịch sử hoàn phí',
    date: 'Ngày',
    amount: 'Số tiền',
    status: 'Trạng thái',
    completed: 'Đã hoàn',
    pending: 'Chờ xử lý',
    failed: 'Thất bại',
    description: 'Mô tả',
    autoRebate: 'Hoàn phí tự động',
    autoRebateDesc: 'Hệ thống sẽ tự động hoàn phí giao dịch vào tài khoản của bạn. Thời gian xử lý: 1-3 ngày làm việc.',
  },
  withdraw: {
    title: 'Rút tiền',
    subtitle: 'Rút tiền về ví của bạn',
    availableBalance: 'Số dư khả dụng',
    withdrawAmount: 'Số tiền rút',
    walletAddress: 'Địa chỉ ví (hoặc UID)',
    network: 'Mạng',
    selectNetwork: 'Chọn mạng',
    enterAmount: 'Nhập số tiền',
    enterWalletAddress: 'Nhập địa chỉ ví (hoặc UID)',
    withdraw: 'Rút tiền',
    minWithdraw: 'Rút tối thiểu: {amount}',
    fee: 'Phí',
    receiveAmount: 'Bạn sẽ nhận được',
    withdrawHistory: 'Lịch sử rút tiền',
    processing: 'Đang xử lý',
    completed: 'Hoàn thành',
    failed: 'Thất bại',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: 'Vui lòng nhập số tiền hợp lệ',
    pleaseEnterWallet: 'Vui lòng nhập địa chỉ ví',
    pleaseSelectNetwork: 'Vui lòng chọn mạng',
    invalidAmount: 'Số tiền không hợp lệ',
    amountTooLow: 'Số tiền thấp hơn mức rút tối thiểu',
    insufficientBalance: 'Số dư không đủ',
    confirmWithdrawal: 'Xác nhận rút tiền',
    withdrawalSubmitted: 'Yêu cầu rút tiền đã được gửi thành công! Kiểm tra Lịch sử để xem trạng thái.',
    withdrawalFailed: 'Rút tiền thất bại',
    note: 'Lưu ý',
    withdrawalNote: 'Phí gas sẽ được trừ từ số tiền rút',
  },
  history: {
    title: 'Lịch sử giao dịch',
    subtitle: 'Xem tất cả giao dịch và rút tiền của bạn',
    transactions: 'Giao dịch',
    withdrawals: 'Rút tiền',
    rebates: 'Hoàn phí',
    date: 'Ngày',
    type: 'Loại',
    amount: 'Số tiền',
    status: 'Trạng thái',
    noTransactions: 'Không có giao dịch',
    noWithdrawals: 'Không có rút tiền',
    noRebates: 'Không có hoàn phí',
    claimNow: 'Claim Ngay',
    claiming: 'Đang claim...',
    readyToClaim: 'Sẵn sàng để claim từ smart contract',
    claimedSuccessfully: 'Claim thành công!',
    failedToClaim: 'Claim thất bại',
    noMoreItems: 'Hết rồi',
    payGas: 'Trả phí gas',
    claimed: 'Đã claim',
    noHistoryFound: 'Không có lịch sử',
    statusCompleted: 'Đã hoàn thành',
    statusPending: 'Đang chờ',
    statusFailed: 'Thất bại',
    statusProcessing: 'Đang xử lý',
    statusRejected: 'Từ chối',
  },
  checkIn: {
    title: 'Điểm danh hàng ngày',
    subtitle: 'Điểm danh mỗi ngày để nhận XP',
    checkIn: 'Điểm danh',
    checkedIn: 'Đã điểm danh',
    todayPoints: 'XP hôm nay',
    totalPoints: 'Tổng XP',
    points: 'XP',
    redeem: 'Đổi quà',
    rewards: 'Phần thưởng',
    vouchers: 'Voucher',
    linkReward: 'Phần thưởng liên kết',
    linkExchange: 'Liên kết tài khoản sàn',
    linkRewardDesc: 'Liên kết tài khoản sàn để nhận XP thưởng',
    rewardHistory: 'Lịch sử phần thưởng',
    availableRewards: 'Phần thưởng khả dụng',
    voucher: 'Voucher',
    gift: 'Quà tặng',
    pointsRequired: 'XP yêu cầu',
    redeemNow: 'Đổi ngay',
    redeemed: 'Đã đổi',
    noRewards: 'Không có phần thưởng',
    shop: 'Shop',
    myCodes: 'Mã',
    backButton: '← Lại',
    noPointsHistory: 'Không có lịch sử XP',
    myRedeemedCodes: 'Mã Đã Nhận',
    yourCode: 'Mã của bạn:',
    codeCopied: 'Đã copy mã!',
    noRedeemedYet: 'Chưa có phần thưởng nào',
    dailyCheckIn: 'Điểm Danh',
    tasks: 'Nhiệm Vụ',
    checkedInSuccessfully: 'Check-in thành công!',
    checkInFailed: 'Check-in thất bại',
    claimedTask: 'Nhận nhiệm vụ thành công!',
    failedToClaimTask: 'Không thể nhận nhiệm vụ',
    insufficientPoints: 'Không đủ XP',
    redeemFailed: 'Đổi thất bại',
    special: 'Đặc Biệt',
    social: 'Xã Hội',
    trading: 'Giao Dịch',
    watchAd: 'Xem Quảng Cáo',
    available: 'khả dụng',
    completed: 'hoàn thành',
    comingSoon: 'Sắp Ra Mắt',
    times: 'lần',
    weeklyLeaderboard: 'Bảng Xếp Hạng XP Tuần',
    leaderboardSubtitle: 'Top người chơi tuần này',
    yourRank: 'Hạng của bạn',
    yourXP: 'XP của bạn',
    you: 'Bạn',
    noLeaderboardData: 'Chưa có dữ liệu bảng xếp hạng',
    prize: 'Phần thưởng',
  },
  profile: {
    title: 'Cá nhân',
    accountInfo: 'Thông tin tài khoản',
    telegramId: 'Telegram ID',
    joinDate: 'Ngày tham gia',
    language: 'Ngôn ngữ',
    english: 'Tiếng Anh',
    vietnamese: 'Tiếng Việt',
    spanish: 'Tiếng Tây Ban Nha',
    portuguese: 'Tiếng Bồ Đào Nha',
    chinese: 'Tiếng Trung',
    indonesian: 'Tiếng Indonesia',
    emailSettings: 'Cài Đặt Email',
    notSet: 'Chưa thiết lập',
    logout: 'Đăng xuất',
    logoutConfirm: 'Bạn có chắc muốn đăng xuất?',
  },
  login: {
    title: 'CashBackHub',
    subtitle: 'Hệ thống hoàn phí giao dịch',
    description: 'Ứng dụng Telegram Mini App',
    hint: 'Vui lòng mở ứng dụng từ Telegram',
    login: 'Đăng nhập',
  },
  exchanges: {
    title: 'Sàn Giao Dịch',
    subtitle: 'Chọn loại giới thiệu',
    chooseReferralType: 'Chọn loại giới thiệu',
    exchangeReferral: 'Giới Thiệu Sàn',
    linkYourUid: 'Liên kết UID',
    copyTrade: 'Copy Trade',
    followTrades: 'Theo dõi giao dịch',
    filterByExchange: 'Lọc theo sàn:',
    allExchanges: 'Tất cả sàn',
    accounts: 'tài khoản',
    account: 'Tài khoản',
    connected: 'Đã kết nối',
    uidCopied: 'Đã sao chép UID!',
    totalRebate: 'Tổng Hoàn Tiền',
    transactionVolume: 'Khối Lượng Giao Dịch',
    waitingForSync: 'Chờ đồng bộ',
    cashbackHubRebate: 'Hoàn Tiền CashbackHub',
    viewReason: 'Xem Lý Do',
    reconnect: 'Kết Nối Lại',
    noAccounts: 'Chưa có tài khoản sàn',
    rejectionReason: 'Lý Do Từ Chối',
    exchangeConnected: 'Kết nối sàn giao dịch thành công!',
    notConfigured: 'Chưa được cấu hình',
    noExchangesAvailable: 'Chưa Có Sàn Khả Dụng',
    pleaseContactSupport: 'Vui lòng liên hệ đội hỗ trợ để thiết lập sàn cho tài khoản của bạn.',
    allAccounts: 'Tất Cả Tài Khoản',
    activeAccounts: 'Đang Hoạt Động',
    pendingAccounts: 'Chờ Duyệt',
    rejectedAccounts: 'Từ Chối',
    totalProfit: 'Tổng Lợi Nhuận',
    noCopyTradeAccounts: 'Chưa có tài khoản copy trade',
    rejectionReasonText: 'UID này chưa được đăng ký trong hệ thống giới thiệu của chúng tôi. Vui lòng liên hệ đội hỗ trợ @backcashhub để được hướng dẫn chi tiết về cách hoàn tất quá trình đăng ký!',
  },
  settings: {
    title: 'Cài Đặt',
    subtitle: 'Tùy chỉnh trải nghiệm và quản lý thông tin tài khoản của bạn',
    telegramNotifications: 'Thông Báo Telegram',
    profile: 'Hồ Sơ',
    telegramNotificationsDesc: 'Nhận thông báo tức thì qua Telegram',
    uid: 'UID',
    connected: 'Đã Kết Nối',
    connect: 'Kết Nối',
    emailVerification: 'Xác Thực Email',
    emailAddress: 'Địa Chỉ Email',
    sendVerificationCode: 'Gửi Mã Xác Thực',
    sending: 'Đang gửi...',
    verificationCode: 'Mã Xác Thực',
    enterCode: 'Nhập mã 6 số từ email của bạn',
    changeEmail: 'Đổi Email',
    resendCode: 'Gửi Lại',
    verifying: 'Đang xác thực...',
    verifyEmail: 'Xác Thực Email',
    codeExpired: 'Mã xác thực đã hết hạn. Vui lòng yêu cầu mã mới.',
    invalidCode: 'Mã xác thực không hợp lệ. Vui lòng thử lại.',
    verificationSent: 'Đã gửi mã xác thực thành công! Kiểm tra email của bạn.',
    emailVerified: 'Xác thực email thành công!',
    failedToSend: 'Gửi mã xác thực thất bại. Vui lòng thử lại.',
    failedToVerify: 'Xác thực email thất bại. Vui lòng thử lại.',
    enterEmailPlaceholder: 'email.cua.ban@example.com',
    enterCodeDesc: 'Nhập mã 6 số từ email của bạn',
  },
  copyTrade: {
    title: 'Copy Trade',
    notConfigured: 'Chưa được cấu hình',
    noExchangesAvailable: 'Chưa Có Sàn Khả Dụng',
    pleaseContactSupport: 'Vui lòng liên hệ đội hỗ trợ để thiết lập sàn cho tài khoản của bạn.',
    linkCopyTradeAccount: 'Liên Kết Tài Khoản Copy Trade',
    selectExchange: 'Chọn Sàn',
    step1: 'Bước 1: Click nút bên dưới để copy trade',
    openCopyTradeLink: 'Mở Link Copy Trade',
    clickToCopyTrade: 'Click để mở link copy trade và làm theo hướng dẫn',
    step2: 'Bước 2: Nhập UID Của Bạn',
    enterYourUid: 'Nhập UID Của Bạn',
    enterUidPlaceholder: 'Nhập UID của bạn trên sàn',
    submit: 'Gửi',
    submitting: 'Đang gửi...',
    pleaseEnterUid: 'Vui lòng nhập UID',
    pleaseSelectExchange: 'Vui lòng chọn sàn',
    pleaseSelectBot: 'Vui lòng chọn bot',
    submittedSuccessfully: 'Gửi tài khoản copy trade thành công! Chờ phê duyệt.',
    accountRejectedPleaseResubmit: 'Tài khoản của bạn đã bị từ chối. Vui lòng gửi lại với thông tin chính xác.',
    disabled: 'Đã vô hiệu hóa',
    accountDisabledMessage: 'Tài khoản này đã bị vô hiệu hóa. Vui lòng liên hệ hỗ trợ để biết thêm thông tin.',
    submitFailed: 'Gửi tài khoản copy trade thất bại',
  },
  rules: {
    title: 'Quy Tắc Hoàn Tiền',
    description: 'Phần trăm hoàn tiền dựa trên mốc lợi nhuận:',
    profitRange: 'Mức Lợi Nhuận',
    rebatePercentage: 'Hoàn Tiền',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: 'Hoàn tiền được tính dựa trên lợi nhuận tăng thêm sau khi trừ phần trăm hoàn của sàn.',
    noRules: 'Chưa có quy tắc hoàn tiền',
  },
};

